import { makeAutoObservable, configure, runInAction, toJS } from 'mobx';
import { CommonTypes } from '@/types/store/common';
import httpClient from '@/tools/httpClient';
import { dashboard } from '@/api';
import { getApplicationUrl } from '@/const/serviceEnv';
import Cookies from 'js-cookie';

configure({ enforceActions: 'observed' });


class DashboardStore implements CommonTypes {
  [key: string]: any;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * 销售报价单列表
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getQuotationList = async (params: any) => {
    const data = await httpClient.post(dashboard.quotation_list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };
  
  /**
   * 方案列表
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getProgramList = async (params: any) => {
    const data = await httpClient.post(dashboard.program_list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };
  /**
   * 获取待发货订单列表
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getDaifaOrderList = async (params: any) => {
    const data = await httpClient.post(dashboard.daifa_order_list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };
  /**
   * 获取代办事项列表
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getTeamNoticeTodoList = async (params: any) => {
    const data = await httpClient.get(dashboard.team_notice_todo_list, {
      params,
      baseURL: getApplicationUrl('liguanjia'),
      headers: {
        Authorization: Cookies.get('liguanjia_member_token'),
      },
    });
    return data;
  };
  /**
   * 设置代办事项状态
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  teamNoticeSetState = async (params: any) => {
    const data = await httpClient.post(dashboard.team_notice_set_state, params, {
      baseURL: getApplicationUrl('liguanjia'),
      headers: {
        Authorization: Cookies.get('liguanjia_member_token'),
      },
      postType: 'formData',
    });
    return data;
  };
  /**
   * 获取用户关注客户列表
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  userFollowCustomerList = async (params: any) => {
    const data = await httpClient.post(dashboard.user_follow_customer__list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };
  /**
   * 获取客户案例详情
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  customerCaseInfo = async (params: any) => {
    const data = await httpClient.post(dashboard.yc_customer_case_info, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };

  /**
   * 获取客户案例
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  customerCaseList = async (params: any) => {
    const data = await httpClient.post(dashboard.yc_customer_case_list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };

  /**
   * 获取广告列表
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  advertisingList = async (params: any) => {
    const data = await httpClient.post(dashboard.yc_advertising_list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };

  /**
   * 获取产品动态
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  productDynamicList = async (params: any) => {
    const data = await httpClient.post(dashboard.yc_product_dynamic_list, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };

  /**
   * 获取产品动态详情
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  productDynamicInfo = async (params: any) => {
    const data = await httpClient.post(dashboard.yc_product_dynamic_info, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };
  /**
   * 客户对象信息
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  customersInfo = async (params: any) => {
    const data = await httpClient.post(dashboard.customersInfo, {
      ...params,
      requestTokenKey: true,
      postType: 'formData',
    });
    return data;
  };

  /**
   * 获取快捷菜单入口
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getQuickMenuAllList = async (params: any) =>
    await httpClient.post(dashboard.getQuickMenuAllList, {
      ...params,
    });

  /**
   * 获取常用快捷菜单入口
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getUsageQuickMenuList = async (params: any) =>
    await httpClient.post(dashboard.getUsageQuickMenuList, {
      ...params,
    });

  /**
   * 获取常用快捷菜单入口
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  saveQuickMenu = async (params: any) =>
    await httpClient.post(dashboard.saveQuickMenu, {
      ...params,
    });

  /**
   * 更新state
   */
  updateState = (params: CommonTypes) => {
    for (const [key, value] of Object.entries(params)) {
      runInAction(() => {
        this[key] = value;
      });
    }
  };
}

export default new DashboardStore();
